import React, { PropsWithChildren } from 'react';
import styles from './dictionary-components.module.scss';

export default function AkSmall({ children }: PropsWithChildren<{}>) {
    return <span className={styles.wwiseAkSmall}>{children}</span>;
}
